<template>
<div id="agribigBox">
  <div class="agriBox">

    <!-- logo和导航 -->
    <div class="topBox clearfix">
      <img src="@/assets/images/logo03.png" alt="" class="logo" @click="$router.push({path:'/'})">
      <ul class="nav clearfix">
        <li v-for="item in navLists" :key="item.name" @click="goPage(item.name)" :class="{'activeNav':item.active}">
          {{item.name}} <br> {{item.value}}
        </li>
        <button class="loginBtn" @click="loginDialog" v-if="ifLOginNow">登录</button>
        <div v-else class="loginInfo">
          当前登录用户：
          <span @click="goToPersonal" style="cursor:pointer;text-decoration:underline;color:#fff">{{loginName}}</span>
          <span @click="signOut" class="singOutTxt">退出</span>
        </div>
      </ul>
    </div>

    <img src="@/assets/images/img05.png" alt="" class="txtImg">

  </div>

  <!-- 公共地图列表 -->
    <div class="listHeader clearfix">
      <img src="@/assets/images/img06.png" alt="" class="icon">
      <span class="more" @click="showMoreMap(1)">更多&gt;&gt;</span>
    </div>
    <ul class="agriMapList clearfix">
      <li v-for="item in pubMapTop4Lists" :key="item.id" @click="goMap(item)">
        <img src="@/assets/images/icon47.png" alt=""  v-if="item.clicks == 0" id="newImgShowIn">
        <img :src="item.thumbnail" alt="">
        <span>{{item.serviceCname}}</span>
      </li>
    </ul>

    <login-box v-show="showORhide" @closeLoginBoxX="closeLoginBoxX" :mapLoginOrindLogin="mapLoginOrindLogin"></login-box>
</div>
</template>

<script>
import request from '@/utils/request'
import loginBox from '@/views/components/loginBox'
export default {
  name: 'index',
  components:{
    loginBox
  },
  data(){
    return {
      mapLoginOrindLogin:1,
      ifLOginNow:true,
      loginName:'',
      indexLists: [],
      selectIndex:'',
      showORhide:false,
      searchFilter:'',
      navLists:[
        {name:'农业',value:'agriculture',active:true},
        {name:'交通',value:'traffic',active:false},
        {name:'自然资源',value:'resource',active:false},
        {name:'医疗',value:'medical',active:false},
        {name:'营销分析',value:'marketing',active:false}
      ],
      //公共地图
      pubMapTop4Lists:[],
      agriMapLists:[],
      //共享地图
      shareMapTop4Lists:[],
      shareMapLists:[],
      dialogVisible:false,
      nowLoginName:''
    }
  },
  created(){
    this.nowLoginName = localStorage.getItem('portalUserName')
    if(this.nowLoginName){
      this.loginName = this.nowLoginName;
      this.ifLOginNow = false;
    }else{
      this.ifLOginNow = true;
      this.loginName = '';
    }
    this.getPubImgList();
    this.getShareImgList();
  },
  watch:{
    nowLoginName(newName,oldName){
      console.log(newName)
      if(newName){
        this.loginName = newName;
        this.ifLOginNow = false;
      }else{
        this.ifLOginNow = true;
        this.loginName = '';
      }
    }
  },
  methods:{
    //更多地图
    showMoreMap(val){
        this.$router.push({path:'/moreMapLists',query:{num:val}})
    },
    //转到个人中心
    goToPersonal(){
      this.$router.push({path:'/personal'})
    },
    //退出登录
    signOut(){
      let userEntity = {};
      userEntity.id = JSON.parse(localStorage.getItem('portalUserId'));
      localStorage.removeItem('portalToken');
      localStorage.removeItem('portalUserName');
      request({url:'/usercenter/logout', method:'post', data: userEntity })
      .then(res => {
          console.log(res);
          if(res.data.code == 200){
            // if(res.data.data == null || res.data.data.username == null){
            //   console.log("session无此用户，返回首页");
            //   return;
            // }
            this.ifLOginNow = true;
            this.userName = res.data.username;
            this.$message({
              message: res.data.data,
              type: 'success'
            })
            
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
          this.$router.push({path:'/'})
      })
      .catch(err => {
      })
    },
    //获取公共地图列表
    getPubImgList(){
      request({url:'/portalmap/gisServerController/findtype?serviceType=01',method:'post'})
      .then(res => {
        console.log(res)
        if(res.data.code == 200){
          this.agriMapLists = res.data.data;
          this.pubMapTop4Lists = this.agriMapLists.slice(0,4);
        }
      })
      .catch(err => {
      })
    },
    //获取公共地图列表
    getShareImgList(){
      request({url:'/portalmap/gisServerController/findtype?serviceType=02',method:'post'})
      .then(res => {
        if(res.data.code == 200){
            this.shareMapLists = res.data.data;
            this.shareMapTop4Lists = this.shareMapLists.slice(0,5);
        }
      }).catch(err => {
      })
    },
    //关闭登录弹框
    closeLoginBoxX(val){
      this.showORhide = val;
    },
    //打开地图
    goMap(val){
      request({url:'/portalmap/gisServerController/visit?id='+val.id,method:'post'})
      this.$router.push({name:'map',query:val});
    },
    showPwd() {
      
    },
    //导航栏
    goPage(val){
      if(val == '农业'){
        return false;
      }else{
        this.$message('即将上线，敬请期待！')
      }
    },
    //搜索
    search(){
      if($.trim(this.searchFilter) == ''){
        this.$message({
              message: '请输入搜索条件',
              type: 'warning'
            });
        return
      }else if(this.selectIndex == ''){
        this.$message({
              message: '请选择索引',
              type: 'warning'
        });
        return
      }
      let options = this.agriMapLists[0];
      options.indexid = this.selectIndex;
      options.searchFilter = this.searchFilter;
      options.indexList = this.indexLists;
      options.isSerch = true;
      this.$router.push({name:'map',query:options});
    },
    //登录弹框
    loginDialog(){
      this.showORhide = true;
      this.mapLoginOrindLogin = 1;
    }
  }
}
</script>

<style scoped>
#agribigBox{height:100%;}
.agriBox{height:70%;background:url('../../assets/images/bg02.png') no-repeat;background-size:100%;}
.agriBox .topBox{padding:0 4%;font-size:12px;}
.agriBox .topBox .logo{width:18%;margin-top:1%}
.agriBox .topBox .logo,.topBox .nav li{
  float:left;
}
.agriBox .topBox .nav li{
  cursor:pointer;
  padding:20px 10px 10px;
  margin-right:70px;
  font-size:12px;
  text-align:left;
}
.agriBox .topBox .nav{padding-top:0;}
.agriBox .topBox .nav,.nav .regBtn{float:right;color:#fff;}
.agriBox .topBox .loginBtn{cursor:pointer;float:left;margin-right:20px;margin-top:20px;padding:6px 20px;border:0;border-radius:20px;background:linear-gradient(to right,#52bdff,#0084ff);color:#fff;font-size:12px;line-height:0;}
.advertTxt{margin-top:4%;font-size:30px;color:#8392ae}
.topBox .loginInfo{float:left;margin-top:20px;}
.topBox .loginInfo img{vertical-align:middle;width:20px;}
.singOutTxt{cursor:pointer;display:inline-block;margin-left:15px;text-decoration:underline;color:#fff}
.txtImg{position:absolute;top:25%;left:5%;width:500px}

.listHeader,.agriMapList{
  width:70%;
  margin:10px auto;
  color:#fff;
  font-size:14px;
}
.listHeader{margin-top:25px;}
.listHeader .icon{float:left;width:90px;}
.listHeader .more{cursor:pointer;float:right;color:#a8b0c7;}
.agriMapList li{position:relative;float:left;width:22%;height:120px;margin-right:4%;margin-bottom:10px;text-align:center;border-radius:10px;box-shadow:0 0 15px #ccc;}
.agriMapList li:last-child{margin-right:0}
.agriMapList li:hover{width:22.8%;margin-left:-.8%;margin-top:-1px;box-shadow:0 0 30px #526281;}
.agriMapList li img,.agriMapList li span{position:absolute;left:0;width:100%;display:block;}
.agriMapList li img{top:0;height:100%;width:100%;border-radius: 10px;}
.agriMapList li span{bottom:0;height:40px;line-height:40px;border-radius:0 0 10px 10px;background:rgba(0,149,5,.4)}
.activeNav{background:linear-gradient(to bottom,rgba(78,186,255,.3),rgba(78,186,255,.2))}


</style>
